import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { IQuotationTraveller, IQuotationVatConfiguration } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { TravellerDataTranslationService } from "libraries/service/traveller-data-translation/traveller-data-translation.service";
import { TravellerXType } from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { VatService } from "app_quotation/shared/services/vat.service";
import { faWalking, IconDefinition, faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'th-traveller',
    template: `
        <ng-template #template>
            <th mat-header-cell class="header-traveller" (click)="toggleVisibility()">
                <div class="traveller-code-container" *ngIf="traveller.externalReference">
                    <strong>{{initials}} {{vatLabel}}</strong>
                    <fa-icon [icon]="isVisible ? iconAngleUp : iconAngleDown" class="traveller-icon"></fa-icon>
                </div>
                <div class="traveller-name-container" *ngIf="traveller.externalReference && isVisible">
                    {{identity}}
                </div>
                <div *ngIf="type" class="traveller-type-container">
                    <em>
                        ({{type}})
                    </em>
                </div>
            </th>
        </ng-template>
    `,
    styles: [ `
        :host {
            display: none
        }

        .traveller-code-container {
            display: flex;
            justify-content: flex-end;
        }

        .traveller-name-container {
            white-space: nowrap;
        }

        .traveller-icon {
            width : 1rem;
            display: inline-block;
            text-align: right;
        }

        th.header-traveller {
            cursor: pointer;
            font-size: 1rem;
            color: #414141;
            padding: .75rem;
            background-color: #ebebeb;
            border-right: 1px solid white;
            border-bottom: 1px solid white;
            font-weight: normal;
            text-align: right;
        }

        em {
            font-style: italic;
            opacity: .6;
        }
    ` ],
})

export class ThTravellerComponent implements OnInit, OnChanges {

    @Input()
    public traveller: IQuotationTraveller;
    @Input()
    public index: number;
    @Input()
    public vatConfiguration: IQuotationVatConfiguration;

    public isVisible: boolean;
    public type: string;
    public identity: string;
    public initials: string;
    public vatLabel: string;

    public iconAngleUp: IconDefinition = faAngleUp;

    public iconAngleDown: IconDefinition = faAngleDown;

    @ViewChild('template', {read: TemplateRef, static: true})
    public readonly template: TemplateRef<ElementRef>;

    constructor(
        private readonly viewContainerRef: ViewContainerRef,
        private readonly travellerDataTranslationService: TravellerDataTranslationService,
        private readonly vatService: VatService
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.traveller && changes.traveller.currentValue) {
            const traveller: IQuotationTraveller = changes.traveller.currentValue;
            this.type = this.travellerDataTranslationService.translateType(traveller.travellerType.toLowerCase() as TravellerXType);
            this.identity = this.travellerDataTranslationService.getTravellerIdentity(traveller);
            this.initials = this.travellerDataTranslationService.getInitials(traveller, this.index);
        }
        if (changes && changes.vatConfiguration && changes.vatConfiguration.currentValue) {
            this.vatLabel = this.vatService.getValueAccordingToVat(changes.vatConfiguration.currentValue,
                '',
                'HT',
                'TTC');
        }
    }

    public toggleVisibility(): void {
        this.isVisible = !this.isVisible;
    }

}
